<template>
  <div class="flex items-center justify-center"
    :class="sizeClasses[size]"
    :style="style">
    <span class="font-bold" :class="[fontClasses[size], isLight ? 'text-gray-800' : 'text-white']">
      {{ name?.charAt(0)?.toUpperCase() }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { colorsUtils } from '../utils/ColorsUtils';

const props = withDefaults(defineProps<{
  name: string;
  color: string;
  size?: 'sm' | 'md' | 'lg';
}>(), {
  size: 'md',
});

const sizeClasses: Record<string, string> = {
  sm: 'w-8 h-8 rounded-[10px]',
  md: 'w-11 h-11 rounded-[13px]',
  lg: 'w-14 h-14 rounded-[16px]',
};

const fontClasses: Record<string, string> = {
  sm: 'text-[13px]',
  md: 'text-[17px]',
  lg: 'text-[20px]',
};

const isLight = computed(() => colorsUtils.getContrastColor(props.color));

const style = computed(() => {
  if (isLight.value) {
    return {
      backgroundColor: props.color,
      border: '1.5px solid rgba(0, 0, 0, 0.10)',
      boxShadow: '0 3px 12px rgba(0, 0, 0, 0.08)',
    };
  }
  return {
    backgroundColor: props.color,
    boxShadow: `0 3px 12px ${props.color}35`,
  };
});
</script>
